export default {
  publish: 'Publish',
  unpublish: 'Unpublish',
  publishAnyway: 'Publish anyway',
  cancel: 'Cancel',
  warningsTitle: 'Publish warnings',
  noWarnings: 'No warnings. Ready to publish.',
  confirmPublish: 'Publish this configurator?',
  preview: {
    plural: 'Preview',
    variant: 'Variant',
    slots: 'Slots',
    zones: 'Zones',
    allowedParts: 'Allowed parts',
    allowedMaterials: 'Allowed materials',
    default: 'default',
    empty: 'No preview data yet',
    noVariants: 'This configurator has no variants',
    model: '3D model',
    noModel: 'No 3D model for this variant',
    playerLoadFailed: 'Failed to load the configurator player',
    controlsTitle: 'Configuration',
    partsLoading: 'loading parts…',
    partsFailed:
      'Some parts could not be loaded and are missing from the scene',
    noControls: 'This variant has nothing to configure',
    noCandidatesForSlot: 'No parts offered for this slot',
    options: 'Options'
  }
};
